import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/campy.webp';
import screenshot_target from '../../../images/letterfunnel/laurensvanmierlo.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Laurens van Mierlo"
      firstname="Laurens"
      companyname="Campy"
      competition="Park4night en Campercontact"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/laurensvanmierlo.js